import { render, staticRenderFns } from "./SkeletonProductDesktop.vue?vue&type=template&id=d62b8590"
import script from "./SkeletonProductDesktop.vue?vue&type=script&lang=js"
export * from "./SkeletonProductDesktop.vue?vue&type=script&lang=js"
import style0 from "./SkeletonProductDesktop.vue?vue&type=style&index=0&id=d62b8590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports